__webpack_require__.p = "/UID-Royal-Family/";